import numeral from 'numeral';

export const getPriceFormat = (price: number): string => {
  return numeral(price).format('0,0')?.replace(',', ' ');
};
